 /* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Modal, Input, Tooltip, Button, Select } from "antd";
import Storage from "../../services/local-store";
import postService from "../../services/httpService";
import userTrackService from "../../services/usertrack-service";
import * as R from "ramda";
import moment from "moment";
import { InfoCircleOutlined } from '@ant-design/icons';
import { UserOutlined } from '@ant-design/icons';
import { MobileOutlined } from '@ant-design/icons';
import './index.scss';






class Queuemodal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      loading: false,
      visible: false,
      showRevisits: false,
      patientUMR: "",
      patientName: "",
      patientCaseType: "",
      revisitValue: "",
      patientDepartment: "",
      patientService: "78677",
      serviceGroupId:"78677",
      userServices: [],
      userDepartments: [],
      uService: [],
      paService: "",
      servDissable: true,
      showBillNumber: true,
      checkBillStatus: "",
      errors: {},
      gender: "",
      patientMobile: "",
      showPaidDropdown: false,
      patientPaymentType: "paid",
      searchpatients: [],
      patientlist: "",
      patientBillNumber: "",
      QType: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.visible === false && this.props.visible) {
      this.setState({ visible: true });
    }
  }
  // async componentWillMount() {
    async componentDidMount() {
    await this.getUserDepartments();
    await this.getUserservice();
    await this.getservice();
  
  const user_data = JSON.parse(localStorage.getItem("user_data"));
}
  getUserDepartments = async () => {
    const user_data = JSON.parse(localStorage.getItem("user_data"));
  
    if (user_data && user_data.unitid) {
      await postService("getQueueDepartments", "POST", { unitid: user_data.unitid }).then(
        (res) => {
          if (res) {
            this.setState({ userDepartments: res.data });
          }
        }
      );
    } else {
      console.error("user_data or user_data.unitid is null or undefined");
    }
  };
  
  getUserservice = async () => {
    const { userDepartments } = this.state;
    let deptId = userDepartments.length && userDepartments[0].department_id;
     await postService("getServicesList", "GET", 	null
    // await postService("getServicesBasedOnUserIdandDeptId", "POST", {
       
    ).then((res) => {
      if (res) {
        this.setState({ userServices: res.data });
        if(res.data && res.data.length==1){
          this.setState({serviceGroupId:res.data[0].id});
        }
      }
    });
  };

  getUserserviceforModal = (patientDepartment) => {
  postService("getServicesList",  "GET", 	null
    // postService("getServicesBasedOnUserIdandDeptId", "POST", {
      // departmentID: patientDepartment
      
    ).then((res) => {
      if (res) {
        this.setState({ userServices: res.data });
      }
    });
  };

  getservice = async () => {
    // const { userServices } = this.state;
    const user_data = JSON.parse(localStorage.getItem("user_data"));
    if(user_data && user_data.unitid){
      // let serviceGroupId = userServices.length && userServices[0].service_group_id;
      // await postService("getMasterServicesList", "GET", null).then((res) => {
      await postService("getMasterServicesList", "POST", {unitID: user_data.unitid}).then(res => {
        if (res) {
          this.setState({ uService: res.data });
        }
      })
    }
    else {
      console.log("User Data is NUll");
    }
  };

  resetState = () => {
    this.setState({
      date: new Date(),
      loading: false,
      visible: false,
      showRevisits: false,
      patientUMR: "",
      patientName: "",
      patientCaseType: "",
      gender: "",
      revisitValue: "",
      patientDepartment: "",
      patientService: "78677",
      paService: "",
      patientBillNumber: "",
      checkBillStatus: "",
      patientMobile: "",
      patientPaymentType: "paid",
      showPaidDropdown: false,
      showBillNumber: true,
      searchpatients: [],
      patientlist: "",
    });
  };
  showModal = () => {
    this.setState({
      patientNameerror: null,
      paServiceerror: null,
      gendererror: null,
      patientBillerror: null,
      patientUMRerror: null,
      patientServiceerror: null,
      patientCaseTypeerror: null,
      patientDepartmenterror: null,
    });
    this.setState({ visible: true });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
      this.props.onmodalChanges();
      this.resetState();
    }, 3000);
  };

  handleChange(value) {
    this.setState({ patientCaseType: value });
  }
  changePaidDropdown(value) {
    if (value === "paid") {
      this.setState({
        showBillNumber: true,
        patientPaymentType: value,
        patientBillNumber: "",
        checkBillStatus: "",
      });
    } else {
      this.setState({
        showBillNumber: false,
        patientPaymentType: value,
        patientBillNumber: "",
        checkBillStatus: "",
      });
    }
  }
  departmentChange(value) {
    this.setState({ patientDepartmenterror: null });
    if (value) {
      this.setState(
        (state) => ({ patientDepartment: value }),
        () => {
          this.getUserDepartments();
          this.getUserservice();
        }
      );
    } else {
      this.setState({
        patientDepartmenterror: "Please Enter Patient Department",
      });
    }
  }
  serviceGroupChange(value) {
    // console.log("serviceGroupChange", value);
    this.setState({ patientServiceerror: null });
    if (value) {
      this.setState(
        (state) => ({ patientService: value }),
        () => {
          this.getUserservice();
          this.getservice();
        }
      );
    } else {
      this.setState({
        patientServiceerror: "Please Enter Patient serviceGroup",
      });
    }
  }
  serviceChange(value) {
    this.setState({ paServiceerror: null });
    if (value) {
      this.setState(
        (state) => ({ paService: value }),
        () => {
          this.getservice();
        }
      );
    } else {
      this.setState({ paServiceerror: "Please Enter Patient service" });
    }
  }

  genderChange(value) {
    this.setState({ gendererror: null });
    if (value) {
      this.setState(
        (state) => ({ gender: value }),
        () => {
          this.getservice();
        }
      );
    } else {
      this.setState({ gendererror: "Please Enter Patient gender" });
    }
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      patientMobileerror: null,
      patientUMR: "",
      patientName: "",
      patientNameerror: null,
      patientBillerror: null,
      patientUMRerror: null,
      patientServiceerror: null,
      patientCaseTypeerror: null,
      patientDepartmenterror: null,
      gendererror: null,
      paServiceerror: null,
    });
    this.props.onmodalChanges();
    this.resetState();
  };
  getPatientUMR(e) {
    this.setState({ patientUMRerror: null });
    if (e.target.value !== null && e.target.value.length > 0) {
      this.setState({ patientUMR: e.target.value });
    } else {
      this.setState({
        patientUMR: e.target.value,
        patientUMRerror: "Please Enter UID",
      });
    }
  }
  getPatientName = (e) => {
    this.setState({ patientNameerror: null });
    if (e.target.value !== null && e.target.value.length > 0) {
      this.setState({ patientName: e.target.value });
    } else {
      this.setState({
        patientName: e.target.value,
        patientNameerror: "Please Enter Name",
      });
    }
    //this.setState({ patientNameerror: e.target.value })
  };

  getPatientMobile = (e) => {
    this.setState({ patientMobileerror: null });
    if (e.target.value) {
      var regex = /^\d{10}$/g;
      var value = e.target.value;
      if (value !== null && value.length > 0 && regex.test(value) === false) {
        this.setState({
          patientMobile: e.target.value,
          patientMobileerror: "Please Enter Valid Mobile Number",
        });
      } else {
        this.setState({ patientMobile: e.target.value });
      }
    } else {
      this.setState({
        patientMobile: e.target.value,
        patientMobileerror: "Please Enter Mobile Number",
      });
    }
    //this.setState({ patientNameerror: e.target.value })
  };

  getPatientsbyBill = (e) => {
    let billnumber = this.state.patientBillNumber;
    if (billnumber !== undefined && billnumber !== null && billnumber !== "") {
      let postData = {
        data: {
          billNo: billnumber,
        },
      };

      postService("getPatientDetailsByBillNo", "POST", postData).then((res) => {
        if (res) {
          if (res.status) {
            if (res.data.length == 1) {
              this.setState({
                searchpatients: res.data,
                patientUMR: res.data[0].umr,
                patientName: res.data[0].name,
                patientMobile: res.data[0].phonenumber,
                patientService: res.data[0].service_groupid,
                paService: res.data[0].serviceid,
                gender: res.data[0].gender,
                patientCaseType: res.data[0].casetype,
                patientDepartment: res.data[0].department_id,
                patientBillerror: "",
                patientUMRerror: "",
                patientNameerror: "",
                patientCaseTypeerror: "",
                patientMobileerror: "",
                patientServiceerror: "",
                patientDepartmenterror: "",
                gendererror: "",
                paServiceerror: "",
              });
            } else if (res.data.length > 1) {
              this.setState({
                searchpatients: res.data,
                patientUMR: res.data[0].umr,
                patientName: res.data[0].name,
                patientMobile: res.data[0].phonenumber,
                patientService: "",
                paService: "",
                gender: "",
                patientCaseType: "",
                patientDepartment: "",
                patientUMRerror: "",
                patientNameerror: "",
                patientMobileerror: "",
              });
            } else {
              this.setState({ searchpatients: res.data });
            }
          }
        } else {
          this.setState({ searchpatients: [] });
        }
      });
    }
  };
  getPatientBillNumber = (e) => {
    this.setState({ patientBillerror: null });
    if (e.target.value !== null && e.target.value.length > 0) {
      this.setState({ patientBillNumber: e.target.value });
    } else {
      this.setState({
        patientBillNumber: e.target.value,
        patientBillerror: "Please Enter Bill Number",
      });
    }
  };
  checkBillNumber(billnumber) {
    let patientType = this.state.patientCaseType;
    if (
      billnumber !== undefined &&
      billnumber !== null &&
      patientType !== undefined &&
      patientType !== null
    ) {
      let postData = {
        data: { patientType: patientType, billnumber: billnumber },
      };
      postService("checkPatientbill", "POST", postData).then((res) => {
        if (res) {
          console.log("billing checking.....");
        
          if (res.status) {
            this.setState({ checkBillStatus: res.data });
          }
        } else {
          this.setState({ checkBillStatus: "invalid" });
        }
      });
    }
  }
  addPatient() {

    let patientService=this.state.patientService;
    console.log("patient_service",patientService);
    if(this.state.userServices && this.state.userServices.length>0 && this.state.userServices[0].id){
      patientService = this.state.userServices[0].id;
    }
    console.log("patient_service after",patientService);
    let patientUMR = this.state.patientUMR;
    let patientName = this.state.patientName;
    let patientCaseType = this.state.patientCaseType;
    let patientMobile = this.state.patientMobile;
    let revisitValue = this.state.revisitValue;
    let patientDepartment = this.state.patientDepartment;
    
    let patientBillNumber = this.state.patientBillNumber;
    let checkBillStatus = this.state.checkBillStatus;
    let paService = this.state.paService;
    let gender = this.state.gender;
    let IPPaymentType = this.state.patientPaymentType;
    let userDepartments = this.state.userDepartments;
    let userServices = this.state.userServices;
    const user_data = JSON.parse(localStorage.getItem("user_data"));
    const department = userDepartments && userDepartments[0];
    //let serviceGroup = userServices.length && userServices[0];
    let serviceGroup = (userServices && userServices.length) ? userServices[0] : null;
    //let serviceGroupId = userServices && userServices.length ? userServices[0].service_group_id : null;
    let servicenames=this.state.userDepartments.filter((item)=>item.id==patientDepartment);
   let newObj = {
      billNumber: patientBillNumber,
      IndentNumber: "",
      billDate: moment().format("YYYY-MM-DD hh:mm:ss"),
      name: patientName,
      UMR: patientUMR,
      AdmissionNo: "",
      NurseStatName: "",
      NurseStatCode: "",
      age: "",
      gender: "",
      phonenumber: patientMobile,
      doctorId: "",
      doctorName: "",
      patientType: "OP",
      paymentType: "",
      patientSelectedDoctor:paService,
      patientSelectedDept:servicenames[0].name,
      billDoneby: user_data && user_data.username ? user_data.username : "",
      serviceData: [
        {
          serviceGroupId:patientService &&patientService,
          // serviceGroupId: serviceGroup && serviceGroup.service_group_id,
          // serviceGroupName: serviceGroup && serviceGroup.service_group_name,
          serviceGroupName:'',
          serviceId: paService,
          serviceName: "",
          departmentID:patientDepartment&&patientDepartment,
          // departmentID: department && department.department_id,
          // departmentName: department && department.departmentname,
          departmentName:'',
          //unitID: user_data.unitid,
          unitID: user_data && user_data.unitid ? user_data.unitid : "",
          unitName: "",
          isCancelled: "NO",
          appointment_datetime: "",
          apptDoctorId: "",
          apptDoctorName: "",
        },
      ],
    };

    if (this.state.QType === "Radiology" && patientBillNumber == "") {
      this.setState({ patientBillerror: "Please Enter Bill Number" });
    }

    if (patientName == "") {
      this.setState({ patientNameerror: "Please Enter Name" });
    }

    if (patientUMR == "") {
      this.setState({ patientUMRerror: "Please Enter UID" });
    }
    if (patientDepartment == "") {
      this.setState({
        patientDepartmenterror: "Please Select Department",
      });
    }
    if (patientService == "") {
      this.setState({
        patientServiceerror: "Please Select Service Group",
      });
    }

    if (paService == "" || paService == null) {
      this.setState({ paServiceerror: "Please Select Service" });
    }
    // if (patientCaseType == "") {
    //   this.setState({
    //     patientCaseTypeerror: "Please Select Patient Type From Bill",
    //   });
    // }
    // if (gender == "") {
    //   this.setState({ gendererror: "Please Select Gender From Bill" });
    // }

    // if (patientMobile == "") {
    //   this.setState({ patientMobileerror: "Please Enter Mobile Number" });
    // }

    if (
      patientName !== "" &&
      patientUMR !== "" &&
      paService !== "" 
      // (patientMobile !== "" && patientMobile.length === 10)
    ) {
      let postData = { data: newObj };
      // let departmentmatch = R.find(
      //   R.propEq("department_id", patientDepartment),
      //   userDepartments
      // );
      // let servicegroupmatch = R.find(
      //   R.propEq("service_group_id", patientService),
      //   userServices
      // );
      // if (departmentmatch === undefined && servicegroupmatch === undefined) {
      //   var This = this;
      //   Modal.error({
      //     maskClosable: false,
      //     zIndex: 1060,
      //     title: "Error",
      //     content:
      //       "Oops! you are trying to add a patient from different department/service.",
      //     onOk() {
      //       This.props.refreshData();
      //     },
      //   });
      // } else {
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Add-Patient",
        date: new Date(),
        meta: postData,
      };
      userTrackService(Userlogobj);
      // console.log(postData);
      postService("addNewPatientFromOperator", "POST", postData).then((res) => {
        let Userlogobjres = {
          user: JSON.parse(Storage.get("user")),
          action: "Add-Patient - response",
          date: new Date(),
          meta: res,
        };
        userTrackService(Userlogobjres);
        var This = this;
        if (res.status) {
          //if (res.checkData == 'invalid') {
          // if(res.status){
          // console.log(res.data);
          this.setState({ loading: false });
          Modal.success({
            maskClosable: false,
            zIndex: 1050,
            title: "Success",
            content: res.message ? res.message : "Patient Added Successfully",
            onOk() {
              This.props.refreshData();
              This.handleCancel();
            },
          });
          //}
        } 
      //  else if (res.status==2) {
      //     //if (res.checkData == 'invalid') {
      //     // if(res.status){
      //     // console.log(res.data);
      //     this.setState({ loading: false });
      //     Modal.error({
      //       maskClosable: false,
      //       zIndex: 1060,
      //       title: "Error123",
      //       content: res.message ? res.message : "Wrong selection of Doctor's Department",
      //       // onOk() {
      //       //   This.props.refreshData();
             
      //       // },
      //     });
      //     //}
      //   } 
        else {
        
          this.setState({ loading: false });
          Modal.error({
            maskClosable: false,
            zIndex: 1060,
            title: "Error",
            content: res.message ?  res.message : "Error!" ,
            onOk() {
              This.props.refreshData();
            },
          });
        }
      });
      // }
    }
  }
  selectPatient(e) {
    e = "{" + e + "}";
    let evnt = JSON.parse(e);
    if (
      evnt.department_id !== undefined &&
      evnt.department_id !== null &&
      evnt.department_id !== ""
    ) {
      this.getUserserviceforModal(evnt.department_id);
      this.setState({
        patientUMR: evnt.umr,
        patientName: evnt.name,
        patientMobile: evnt.phonenumber,
        patientService: evnt.service_groupid,
        paService: evnt.serviceid,
        gender: evnt.gender,
        patientCaseType: evnt.casetype,
        patientDepartment: evnt.department_id,
        patientBillerror: "",
        patientUMRerror: "",
        patientNameerror: "",
        patientCaseTypeerror: "",
        patientMobileerror: "",
        patientServiceerror: "",
        patientDepartmenterror: "",
        gendererror: "",
        paServiceerror: "",
      });
    }
  }

  render() {
    const Option = Select.Option;
    const {
      visible,
      searchpatients,
      uService,
      userServices,
      userDepartments,
      showRevisits,
      showBillNumber,
      showPaidDropdown,
    } = this.state;

    //console.log('uService',uService);
     //console.log('userServices',userServices);
    // console.log(  "userDepartments",  userDepartments,);
  

    // rowSelection object indicates the need for row selection
    // const showRevisits = this.state.showRevisits;
    // const showBillNumber = this.state.showBillNumber;
    // const showPaidDropdown = this.state.showPaidDropdown;
    //let userServices = this.state.userServices;
    //let { uService } = this.state;
    return (
      <Modal
        visible={visible}
        zIndex={1040}
        onCancel={this.handleCancel.bind(this)}
        footer={null}
        destroyOnClose={true}
        
       
      >
        <div className="mx-3 my-0 p-2 k-modal" style={{backgroundColor: '#f4f4f4'}}>
          <div className="row">
            <div className="col-12 mb-3">
              <h2 className="text-center">Add New Patient </h2>
            </div>
            <div className="col-12 mb-3">
              <Input
                placeholder="UID Code"
                prefix={
                  // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                 <UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                suffix={
                  <Tooltip>
                    {/* <Icon
                      type="info-circle"
                      style={{ color: "rgba(0,0,0,.45)" }}
                    /> */}
                    
                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
                onBlur={this.getPatientUMR.bind(this)}
                onChange={this.getPatientUMR.bind(this)}
                value={this.state.patientUMR}
                // disabled={true}
              />
              <small className="text-danger">
                {this.state.patientUMRerror}
              </small>
            </div>
            <div className="col-12 mb-3">
              <Input
                placeholder="Patient Name"
                prefix={
                  // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                }
                suffix={
                  <Tooltip>
                    {/* <Icon
                      type="info-circle"
                      style={{ color: "rgba(0,0,0,.45)" }}
                    /> */}
                   

<InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
                onBlur={this.getPatientName.bind(this)}
                onChange={this.getPatientName.bind(this)}
                value={this.state.patientName}
                // disabled={true}
              />
              <small className="text-danger">
                {this.state.patientNameerror}
              </small>
            </div>
            <div className="col-12 mb-3">
              <Input
                placeholder="Mobile Number"
                prefix={
                  // <Icon type="mobile" style={{ color: "rgba(0,0,0,.25)" }} />
                 <MobileOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                }
                suffix={
                  <Tooltip>
                    {/* <Icon
                      type="info-circle"
                      style={{ color: "rgba(0,0,0,.45)" }}
                    /> */}
                 

<InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
                onBlur={this.getPatientMobile.bind(this)}
                onChange={this.getPatientMobile.bind(this)}
                value={this.state.patientMobile}
                // disabled={true}
              />
              {/* <small className="text-danger">
                {this.state.patientMobileerror}
              </small> */}
            </div>
            <div className="col-12 mb-3">
              <Input
                placeholder="Bill Number"
                prefix={
                  // <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  

<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                }
                suffix={
                  <Tooltip>
                    {/* <Icon
                      type="info-circle"
                      style={{ color: "rgba(0,0,0,.45)" }}
                    /> */}
                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
                onBlur={this.getPatientBillNumber.bind(this)}
                onChange={this.getPatientBillNumber.bind(this)}
                value={this.state.patientBillNumber}
                // disabled={true}
              />
              {this.state.QType === "Radiology" && (
                <small className="text-danger">
                  {this.state.patientBillerror}
                </small>
              )}
            </div>
            
            <div className="col-12 mb-3">
              <Select
                // className="hide_department"
                showSearch
                optionFilterProp="children"
                value={this.state.patientDepartment}
                style={{ width: "100%" }}
                onChange={this.departmentChange.bind(this)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                dropdownMatchSelectWidth={false}
                // defaultValue={
                //   userDepartments.length > 0
                //     ? userDepartments[0]["department_id"]
                //     : null
                // }
                // disabled={true}
                visible={false}
              >
                <Option value="">Select Department</Option>

                {userDepartments.map((d, i) => {
                  return (
                    <Option value={d.id} key={i}>
                      {d.name}
                    </Option>
                  );
                })}
              </Select>
              <small className="text-danger">
                {this.state.patientDepartmenterror}
              </small>
            </div>
            
            <div className="col-12 mb-3">
              <Select
                showSearch
                optionFilterProp="children"
                // className="hide_department"
                // value={this.state.userServices && this.state.userServices.id != '78677'?"CONSULTATION":this.state.patientService}
                value="CONSULTATION"

                style={{ width: "100%" }}
                onChange={this.serviceGroupChange.bind(this)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                // defaultValue={
                //   userServices.length > 0
                //     ? userServices[0]["service_group_id"]
                //     : null
                // }
                 disabled={true}
                dropdownMatchSelectWidth={false}
                dropdownClassName="custom-dropdown"
                // dropdownStyle={{ width: "80px",border:"2px solid red" }}
                visible={false}
              >
                {/* <Option value="">Select Service Group </Option> */}
                {/* {userServices && userServices.map((d, i) => {
                  return (
                    <Option value={d.id} key={i}>
                      {d.name}
                    </Option>
                  );
                })} */}
              </Select>
              <small className="text-danger">
                {this.state.patientServiceerror}
              </small>
            </div>

            <div className="col-12 mb-3">
              <Select
                showSearch
                optionFilterProp="children"
                value={this.state.paService}
                style={{ width: "100%" }}
                onChange={this.serviceChange.bind(this)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ minWidth: "200px", maxWidth: "435px" }}
              >
                <Option value="" >Select Service  </Option>
                {uService.map((d, i) => {
                  return (
                    <Option value={d.id} key={i}>
                      {d.name}
                    </Option>
                  );
                })}
              </Select>
              <small className="text-danger">{this.state.paServiceerror}</small>
            </div>

            <div className="col-12 text-center mt-3">
              <Button
                className="btn-magenta"
                onClick={this.addPatient.bind(this)}
              >
                Add
              </Button>
              <Button className="btn-dark-red" onClick={this.handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default Queuemodal;
